var map = {
	"./cert-E-commerce-hkgcsmeaa.jpg": 434,
	"./cert-customer-hkgcsmeaa.jpg": 435,
	"./cert-finance-hkgcsmeaa.jpg": 437,
	"./cert-fsi-hkgcsmeaa.jpg": 439,
	"./cert-general-staff-a-hkgcsmeaa.jpg": 441,
	"./cert-general-staff-hkgcsmeaa.jpg": 443,
	"./cert-general2024-hkgcsmeaa.jpg": 371,
	"./cert-hr-hkgcsmeaa.jpg": 444,
	"./cert-it-hkgcsmeaa.jpg": 445,
	"./cert-market-hkgcsmeaa.jpg": 446,
	"./cert-ngo-hkgcsmeaa.jpg": 447,
	"./cert-senior-manager-hkgcsmeaa.jpg": 449,
	"./cert-startup-hkgcsmeaa.jpg": 450,
	"./cert-student-hkgcsmeaa.jpg": 452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3272;